/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface TAPTransactionRequest {

    /**
     * Type of the related payment activity
     */
    kind?: string;

    /**
     * Dollar amount of the commission
     */
    dollar_amount?: string;

    /**
     * Amount the commission is based on, in dollars
     */
    dollar_commissionable_amount?: string;

    /**
     * Currency code
     */
    currency_code?: string;

    /**
     * True if this transaction has been approved
     */
    approved?: boolean;

    /**
     * Description of this transaction
     */
    note?: string;

    /**
     * When this transaction was sent to shortlist
     */
    posted_at?: string;

    /**
     * When this transaction happened
     */
    transacted_at?: string;

    /**
     * Name of the membership product
     */
    product_name?: string;

}

@Model('TAPTransaction')
export class ApiTAPTransaction extends BaseModel implements TAPTransactionRequest {

    /**
     * Type of the related payment activity
     */
    
    
    kind: string;

    /**
     * Dollar amount of the commission
     */
    
    
    dollar_amount: string;

    /**
     * Amount the commission is based on, in dollars
     */
    
    
    dollar_commissionable_amount: string;

    /**
     * Currency code
     */
    
    
    currency_code: string;

    /**
     * True if this transaction has been approved
     */
    
    
    approved: boolean;

    /**
     * Description of this transaction
     */
    
    
    note: string;

    /**
     * When this transaction was sent to shortlist
     */
    
    
    posted_at: string;

    /**
     * When this transaction happened
     */
    
    
    transacted_at: string;

    /**
     * Name of the membership product
     */
    
    
    product_name: string;

}
